<!-- 个人信息 -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">个人信息</p>
		</div>

		<ul class="list">
			<li>
				<span class="name">头像</span>
        <van-uploader :after-read="updateHeadimg">
          <div class="item-sidebar">
            <img :src="userInfo.headimg || require('../assets/avatar.png')" class="avatar" v-if="isLogin">
            <img src="../assets/avatar.png" class="avatar" v-else>
            <img src="../assets/back-icon.png" class="back-icon">
          </div>
        </van-uploader>
      </li>
			<li>
				<span class="name">昵称</span>
				<div class="item-sidebar">
          <span class="msg" v-if="isLogin">
            <van-field input-align="right" style="padding: 0" v-model="userInfo.name" @blur="update" placeholder="请输入用户名" />
          </span>
          <span class="msg" v-else>未登录</span>
					<img src="../assets/back-icon.png" class="back-icon">
				</div>
			</li>
		</ul>

		<div class="btn-box">
			<button type="button" @click="logout()">退出登录</button>
		</div>

	</div>
</template>

<script>
import {Dialog, Toast} from "vant";
import {uploadFile, UserCenterService} from "@/common/service";

  export default {
		components: {},
		data() {
			return {
        isLogin: false,
        userInfo: {},
			};
		},
		mounted() {
      try {
        this.userInfo = JSON.parse(localStorage.getItem('user_info') || '');
      } catch (e) {}
      this.isLogin = this.userInfo.id > 0;
    },
		methods: {
      updateHeadimg({ file }) {
        return uploadFile(file).then(({ data }) => {
          this.update({ headimg: data });
        });
      },
      update(params = {}) {
        return UserCenterService.updateUserInfo({
          name: this.userInfo.name,
          headimg: this.userInfo.headimg,
          ...params,
        }).then(({ msg }) => {
          this.userInfo = {...this.userInfo, ...params};
          localStorage.setItem('user_info', this.userInfo);
          Toast(msg);
        });
      },
      logout() {
        Dialog.confirm({
          title: '标题',
          message: '确定退出登录？',
        }).then(() => {
          localStorage.clear();
          this.$router.push('/');
        })
      }
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		min-height: 100vh;
		background-color: #F4F4F4;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 54px 15px 0;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFFFFF;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 10px;
		padding: 16px 14px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 16px;
	}

	.list>li:last-child {
		margin-bottom: 0;
	}

	.name {
		color: #222222;
		font-size: 14px;
		font-weight: 500;
	}

	.item-sidebar {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.avatar {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		object-fit: cover;
	}

	.back-icon {
		width: 4px;
		margin-left: 6px;
	}

	.msg {
		flex: 1;
		color: #999999;
		font-size: 13px;
	}

	.btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 26px 0;
	}

	.btn-box>button {
		width: 100%;
		height: 48px;
		line-height: 48px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #2A63F3;
		font-size: 18px;
		border-radius: 10px;
		background-color: #FFFFFF;
	}
</style>
